<template>
  <div class="main-container" v-if="history.title !== undefined">
    <span class="title">{{ history.title }}</span>
    <span class="sub-title">อัพเดตล่าสุด</span>
    <div class="card-container">
      <sectionReservation :reservation="history.reserveInfo" />
      <sectionJob :job="history.jobInfo" />
    </div>
    <span class="sub-title" v-if="history.cancelInfo">การยกเลิก</span>
    <div class="full-container" v-if="history.cancelInfo">
      <div class="button-container">
        <button @click="changePage(-1)" v-if="page !== 0 && history.cancelInfo.length > 2">
          <img src="https://storage.healthathome.in.th/b3462b96-0ed8-44b1-9381-aea7a401564d.svg">
        </button>
      </div>
      <div class="card-container">
        <sectionCancel :cancel="history.cancelInfo[page]" />
        <sectionCancel :cancel="history.cancelInfo[page + 1]" />
      </div>
      <div class="button-container">
        <button @click="changePage(1)" v-if="page !== history.cancelInfo.length - 2  && history.cancelInfo.length > 2">
          <img src="https://storage.healthathome.in.th/76034650-d8cc-4d87-b300-df412224d060.svg">
        </button>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>

<style lang="scss" scoped>
  .main-container {
    padding: 156px 100px 100px 100px;
    background-color: #F1F3F6;
    display: flex;
    flex-direction: column;
    margin-bottom: -102px;
  }

  .title {
    font-family: 'Sukhumvit-Bold';
    line-height: 57px;
    font-size: 36px;
    color: #434B61;
    margin-bottom: 32px;
  }

  .sub-title {
    font-family: 'Sukhumvit-Bold';
    line-height: 35px;
    font-size: 22px;
    color: #434B61;
    margin-bottom: 16px;
  }

  .card-container {
    margin-bottom: 80px;
    display: grid;
    grid-column-start: col-start 2;
    grid-template-columns: calc(50% - 12px) calc(50% - 12px);
    column-gap: 24px;
    width: 100%;
  }

  .full-container {
    align-self: center;
    width: 100vw;
    display: flex;
    flex-direction: row;

    .button-container {
      min-width: 110px;
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        min-width: 48px;
        max-width: 48px;
        min-height: 48px;
        max-height: 48px;
        margin-bottom: 50px;
        padding: 0;
        background: none;
        border: 0;

        &:hover {
          opacity: 0.7;
        }

        &:focus {
          outline: none;
        }
      }
    }
  }
</style>

<script>
import sectionReservation from '@/components/shared/SectionReservation'
import sectionJob from '@/components/shared/SectionJob'
import sectionCancel from '@/components/shared/SectionCancel'

export default {
  name: 'SectionReservation',
  components: {
    sectionReservation,
    sectionJob,
    sectionCancel,
  },
  data () {
    return {
      fullscreenLoading: false,
      history: {},
      page: 0,
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    reservationId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.getHistory()
  },
  methods: {
    async getHistory () {
      try {
        this.fullscreenLoading = true
        this.history = await this.$api.Reservation.history(this.reservationId)
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    changePage (tranform) {
      this.page = this.page + tranform
    },
  },
}
</script>
